// Dependencies
require("webstrap/type");
require("grid");
require("modaal");

// Styles
require("./gallery-1-1.scss");

// jQuery
// 
// Must be instanciated before requiring
// jquery-validation
//
var $ = jQuery = require('jquery');

//Initialize Lightbox
$('.js-gallery-item').modaal({
    type: 'image',
    hide_close: true
});

//Unbind modaal and remove href under 700px
if ($(window).width() < 700) {
    $('.js-gallery-item').unbind().removeAttr('href');
}


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/gallery-1/view-1/index.js
// module id = 200
// module chunks = 0